$(document).ready(function ($) {
  const $headerBody = $(".header__body");

  const desktopPageOffset =
    parseInt($headerBody.data("scroll-desktop"), 10) || 0;
  const mobilePageOffset = parseInt($headerBody.data("scroll-mobile"), 10) || 0;

  const animationOnScroll = $headerBody.data("animation-on-scroll") || false;

  const $header = $(".header");
  const $wrapper = $(".wrapper");
  const $headerWrapper = $(".header-wrapper");
  const $headerAd = $(".header-ad");
  const $firstSection = $wrapper.children(
    ".section:first:not(.section--results)"
  );
  const headerNotDisplayed = $headerAd.css("display") == "none";
  const $wpadminbar = $("#wpadminbar");

  function stuckHeader(winST, hasLeaderBoardAd, isMobile) {
    const pageOffset = isMobile ? mobilePageOffset : desktopPageOffset;

    if (hasLeaderBoardAd && !headerNotDisplayed && animationOnScroll) {
      const isSticky = winST > pageOffset;
      if ($wpadminbar.length == 0) {
        $header.toggleClass("is-sticky", isSticky);
      } else {
        $header.toggleClass("is-sticky is-admin-panel-visible", isSticky);
      }

      if (isSticky) {
        $header.css({
          transform: `translateY(-${$headerBody.outerHeight()}px)`,
          transition: "all .7s",
        });
        $firstSection.css({
          transform: pageOffset <= 350 ? `translateY(-363px)` : `translateY(0)`,
          transition: "all .7s",
        });
        $firstSection.addClass("is-header-sicky");
      } else {
        $header.css("transform", "translateY(0)");
        $firstSection.css({
          transform: `translateY(0)`,
        });
        $firstSection.removeClass("is-header-sicky");
      }

      $(".header-wrapper").toggleClass("is-fixed", winST > 0);
      $headerWrapper.css({
        transform:
          winST > pageOffset
            ? `translateY(-${$headerAd.outerHeight()}px)`
            : "translateY(0)",
        transition: "all .7s",
      });
    } else {
      const isFixed = winST > $(".header .header__bar").offset()?.top;
      if ($wpadminbar.length == 0) {
        $header.toggleClass("is-fixed", isFixed);
      } else {
        $header.toggleClass("is-fixed is-admin-panel-visible", isFixed);
      }

      if (isFixed) {
        $firstSection.addClass("is-header-sicky");
      } else {
        $firstSection.removeClass("is-header-sicky");
      }
    }
  }

  function loadLeaderBoardAd() {
    const ldbAdImage = $(".ldb-ad img");
    const isMobile = $(window).outerWidth() <= 480;
    const src = isMobile
      ? ldbAdImage.data("src-mobile")
      : ldbAdImage.data("src-desktop");
    ldbAdImage.attr("src", src);
  }

  $(window).on("load scroll", function () {
    if ($("body").hasClass("sales")) return false;

    const winST = $(window).scrollTop();
    const hasLeaderBoardAd = !$headerAd.hasClass("hidden");
    const isMobile = $(window).outerWidth() <= 480;

    stuckHeader(winST, hasLeaderBoardAd, isMobile);
  });

  $(window).on("load", function () {
    loadLeaderBoardAd();
  });
});
